import React from 'react'
import { HeadingElementTypes } from './types'

const H1 = ({ children, ...rest }: HeadingElementTypes) => <h1 {...rest}>{children}</h1>
const H2 = ({ children, ...rest }: HeadingElementTypes) => <h2 {...rest}>{children}</h2>
const H3 = ({ children, ...rest }: HeadingElementTypes) => <h3 {...rest}>{children}</h3>
const H4 = ({ children, ...rest }: HeadingElementTypes) => <h4 {...rest}>{children}</h4>
const H5 = ({ children, ...rest }: HeadingElementTypes) => <h5 {...rest}>{children}</h5>
const H6 = ({ children, ...rest }: HeadingElementTypes) => <h6 {...rest}>{children}</h6>

export const DynamicHeading: React.FC<HeadingComponentTypes> = ({ text, as, ...rest }) => {
  const headings = {
    h1: H1,
    h2: H2,
    h3: H3,
    h4: H4,
    h5: H5,
    h6: H6
  }
  const Heading = headings[as]
  return <Heading {...rest}>{text}</Heading>
}
